import { useEffect, useState } from "react";
import NocService from "./NocService";
import ApiClient from "../http/ApiClient";
import { Await } from "react-router-dom";

const EmpDetailsForm = (props) => {
  const [formValues, setFormValues] = useState({});
  const [designation, setDesignation] = useState([]);
  const [dept, setDept] = useState([]);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSentOtp, setIsSentOtp] = useState(false);
  const [remainingTime, setRemainingTime] = useState(120);
  const [selectedLevel, setSelectedLevel] = useState("Y");

  useEffect(() => {
    getDept();
  }, []);


  const resetForm = () => {
    setFormValues({});
    setShowAdditionalFields(false);
    setIsSentOtp(false);
    setRemainingTime(120);
    setIsDisabled(false);
    document.querySelectorAll('.form-control').forEach((input) => {
      input.classList.remove('is-invalid');
      input.value = '';
    });
  };

  const saveData = () => {
    if (document.getElementById('mobileOtp').value === '') {
      alert("Please enter OTP");
      return;
    }

    NocService.getNocByPass(formValues.passportNumber)
      .then((result) => {
        if (result.applicationId == null) {
          return NocService.saveDraftNoc(formValues).then((result) => {
            if (result.applicationId != null) {
              document.cookie = `name=${formValues.name};`;
              document.cookie = `designation=${formValues.designation};`;
              props.callBack(formValues.passportNumber, 'D');
            } else {
              props.callBack(formValues.passportNumber, 'E');
            }
          });
        } else {
          props.callBack(formValues.passportNumber, result.applicationStatus);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 500) {
          alert("An error occurred while processing your request. Please try again later.");
          resetForm();
        } else {
          alert("An unexpected error occurred. Please try again.");
          resetForm();
        }
      });
  };


  const getDesig = () => {
    NocService.getDesignation().then((result) => {
      setDesignation(result);
    });
  };


  const districts = [
    { id: 33, name: "Karimnagar" },
    { id: 49, name: "Siddipet" },
    { id: 36, name: "Mahabubabad" },
    { id: 39, name: "Medak" },
    { id: 58, name: "Narayanpet" },
    { id: 45, name: "Peddapalli" },
    { id: 47, name: "Ranga Reddy" },
    { id: 52, name: "Wanaparthy" },
    { id: 53, name: "Warangal" },
    { id: 32, name: "Kamareddy" },
    { id: 35, name: "Komuram Bheem Asifabad" },
    { id: 43, name: "Nirmal" },
    { id: 55, name: "Yadadri Bhuvanagiri" },
    { id: 27, name: "Bhadradri Kothagudem" },
    { id: 56, name: "Hyderabad" },
    { id: 57, name: "Mulugu" },
    { id: 44, name: "Nizamabad" },
    { id: 48, name: "Sangareddy" },
    { id: 54, name: "Hanumakonda" },
    { id: 34, name: "Khammam" },
    { id: 38, name: "Mancherial" },
    { id: 42, name: "Nalgonda" },
    { id: 29, name: "Jangaon" },
    { id: 40, name: "Medchal Malkajgiri" },
    { id: 41, name: "Nagarkurnool" },
    { id: 51, name: "Vikarabad" },
    { id: 26, name: "Adilabad" },
    { id: 28, name: "Jagtial" },
    { id: 30, name: "Jayashankar Bhupalapally" },
    { id: 31, name: "Jogulamba Gadwal" },
    { id: 37, name: "Mahabubnagar" },
    { id: 46, name: "Rajnna Sircilla" },
    { id: 50, name: "Suryapet" }
  ];


  const getDept = () => {
    NocService.getDept().then((result) => {
      setDept(result);
    });
  };

  const sendOtp = () => {
    const fieldsToCheck = [
      '#name',
      '#department',
      '#stateOnly',
      '#workingInstitute',
      '#designation',
      '#passportNumber',
      '#email',
      '#mobile'
    ];

    let isValid = true;
    fieldsToCheck.forEach(fieldSelector => {
      const field = document.querySelector(fieldSelector);
      if (!field || !field.value.trim()) {
        isValid = false;
        if (field) {
          field.classList.add('is-invalid');
        }
      } else {
        field.classList.remove('is-invalid');
      }
    });
    if (selectedLevel === 'N') {
      const districtField = document.querySelector('#district');
      if (!districtField || !districtField.value.trim()) {
        isValid = false;
        if (districtField) {
          districtField.classList.add('is-invalid');
        }
      } else {
        districtField.classList.remove('is-invalid');
      }
    }

    if (!isValid) {
      alert('Please fill in all required fields.');
      return;
    }

    const passportField = document.querySelector('#passportNumber');
    const passportNumber = passportField.value.trim();
    if (!passportNumber.match(/^[A-Z]\d{2}\d{5}$/)) {
      isValid = false;
      passportField.classList.add('is-invalid');
    } else {
      passportField.classList.remove('is-invalid');
    }
    if (!isValid) {
      alert('Please enter a valid passport number.');
      return;
    }

    validatePassport(passportNumber)
      .then((isValidPassport) => {
        if (!isValidPassport) {
          console.log('Invalid passport number');
          alert("Please provide a valid unique passport number");
          passportField.classList.add('is-invalid');
          return; // Stop further execution if the passport is invalid
        }

        let isEmailField = true;
        const emailField = document.querySelector('#email');
        const emailValue = emailField.value;
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(emailValue)) {
          isEmailField = false;
          emailField.classList.add('is-invalid');
        } else {
          emailField.classList.remove('is-invalid');
        }
        if (!isEmailField) {
          alert("Email is invalid");
          return;
        }



        let isMobileValid = true;
        const mobileField = document.querySelector('#mobile');
        if (!mobileField.value.match(/^[6789]\d{9}$/)) {
          isMobileValid = false;
          mobileField.classList.add('is-invalid');
        } else {
          mobileField.classList.remove('is-invalid');
        }

        if (!isMobileValid) {
          alert('Please ensure mobile contains only numbers of 10 digits and starts with 6,7,8 and 9');
          return;
        }
        NocService.sendOtp(formValues.mobile).then((result) => {
          alert("OTP sent Successfully");
          setShowAdditionalFields(true);
          document.getElementById('sendOtp').style.display = 'none';
        });

        setIsSentOtp(true);
        setIsDisabled(true);

        let timer = setInterval(() => {
          setRemainingTime((prevTime) => {
            if (prevTime === 0) {
              clearInterval(timer);
              setIsDisabled(false);
              return 120; // Reset remaining time when timer ends
            }
            return prevTime - 1; // Decrease remaining time by 1 second
          });
        }, 1000);

        // Clear the timer after 30 seconds
        setTimeout(() => {
          clearInterval(timer);
          setIsDisabled(false);
          setRemainingTime(120); // Reset remaining time after 30 seconds
        }, 120000);
      })
      .catch((error) => {
        console.error('Error validating passport number:', error);
      });
  };

  const handleInput = (event) => {
    var { name, value } = event.target;

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const validatePassport = (value) => {
    return NocService.getNocByPass(value)
      .then((result) => {
        if (result.applicationId === null || result.applicationStatus !== 'S') {
          return true;
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.error('Error validating passport number:', error);
        return false; // Consider passport as invalid in case of an error
      });
  };

  const handleLevelChange = (event) => {
    const value = event.target.value;
    setSelectedLevel(value);
  };


  return (
    <>
      <div className="pagetitle">
        <h1></h1>
      </div>

      <section className="section">
        {/* Form fields before Send OTP */}
        < div className="row g-3">
          <div className="col-md-6">
            <label htmlFor="name" className="form-label">
              Name of the Employee<span className="text-danger">*</span>
            </label>
            <input type="text" className="form-control" onChange={handleInput} id="name" name="name" />
          </div>

          <div className="col-md-6">
            <label htmlFor="department" className="form-label">
              Department<span className="text-danger">*</span>
            </label>
            <select className="form-control" onChange={handleInput} id="department" name="department">
              <option value="">[Select Department]</option>
              {dept.map((row, index) => (
                <option key={index} value={row.deptId}>
                  {row.deptName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6">
            <label htmlFor="stateOnly" className="form-label">
              Working Institute Level <span className="text-danger">*</span>
            </label>
            <select className="form-control" onChange={(e) => { handleLevelChange(e); handleInput(e); }} id="stateOnly" name="stateOnly" >
              <option value="">[Select Name of the Office Level]</option>
              <option value="Y">State Level</option>
              <option value="N">District Level</option>
            </select>
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="district" className="form-label">
              District<span className="text-danger">*</span>
            </label>
            <select className="form-control" onChange={handleInput} id="district" name="district">
              <option value="">[Select District]</option>
              {districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.name}
                </option>
              ))}
            </select>
          </div> */}
          {selectedLevel === 'N' && (
            <div className="col-md-6">
              <label htmlFor="district" className="form-label">
                District<span className="text-danger">*</span>
              </label>
              <select className="form-control" onChange={handleInput} id="district" name="district">
                <option value="">[Select District]</option>
                {districts.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="col-md-6">
            <label htmlFor="workingInstitute" className="form-label">
              Name of the Office<span className="text-danger">*</span>
            </label>
            <input type="text" className="form-control" onChange={handleInput} id="workingInstitute" name="workingInstitute" />
          </div>
          <div className="col-md-6">
            <label htmlFor="designation" className="form-label">
              Designation<span className="text-danger">*</span>
            </label>
            <input type="text" className="form-control" onChange={handleInput} id="designation" name="designation" />
          </div>
          <div className="col-md-6">
            <label htmlFor="passportNumber" className="form-label">
              Passport Number<span className="text-danger">*</span>
            </label>
            <input type="text" className="form-control" onChange={handleInput} id="passportNumber" name="passportNumber" maxLength={8} />
          </div>
          <div className="col-md-6">
            <label htmlFor="email" className="form-label">
              Email<span className="text-danger">*</span>
            </label>
            <input type="text" className="form-control" onChange={handleInput} id="email" name="email"
              pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" required />
          </div>
          <div className="col-md-6">
            <label htmlFor="mobile" className="form-label">
              Mobile Number<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              onChange={handleInput}
              id="mobile"
              name="mobile"
              pattern="^[6789][0-9]{9}$"
              inputMode="numeric"
              title="Please enter a 10-digit number"
              minLength={10}
              maxLength={10}
              required
            />
          </div>
          <div className="col-md-12">
            <div className="text-center" style={{ marginBottom: '10px' }}>
              <button type="button" onClick={sendOtp} className="btn btn-primary" id="sendOtp" disabled={isSentOtp}>
                Send OTP
              </button>
            </div>
          </div>
        </div>

        {/* Additional fields after Send OTP */}
        {showAdditionalFields && (
          <>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row g-3">
                      <div className="col-md-12">
                        <label htmlFor="mobileOtp" className="form-label">
                          OTP
                        </label>
                        <input type="text" onChange={handleInput} className="form-control" id="mobileOtp" name="mobileOtp" maxLength={6} />
                      </div>
                      <div className="col-md-12 text-center">
                        <button type="button" onClick={sendOtp} className="btn btn-secondary" id="resendOtpButton" disabled={isDisabled}>
                          Resend OTP ({remainingTime} seconds)
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-3">
              <div className="text-center">
                <button type="button" onClick={saveData} className="btn btn-primary">
                  Submit
                </button>
              </div>
            </div>
          </>
        )}
      </section >
    </>
  );
};

export default EmpDetailsForm;
